// src/shared/store-coords.js — parsing and formatting a shop's coordinate.
//
// Shared because BOTH admin bundles touch it and they are separate esbuild
// outputs: adminPanels (loads the field, captures from GPS) and uploads/stores
// (saves it). A second copy of the validation would be a second definition of
// what counts as a valid coordinate, and the two would drift.
//
// The format is one text box holding "lat, lng" rather than two number inputs,
// because that is exactly what Google Maps puts on the clipboard when you
// right-click a spot — so pasting works with no reformatting.

// "25.118, 55.200" -> { lat, lng }; anything else -> null.
//
// Out-of-range values are REFUSED rather than clamped. A swapped pair, a stray
// digit or a half-typed number has to fail loudly here: the alternative is a
// store that quietly points at the sea and is never matched again, with
// nothing on screen to say so.
export function parseCoords(text) {
  const raw = String(text == null ? '' : text).trim();
  if (!raw) return null;
  const parts = raw.split(',').map((x) => x.trim());
  if (parts.length !== 2) return null;
  const lat = Number(parts[0]);
  const lng = Number(parts[1]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  // 0,0 is Null Island, in the Gulf of Guinea. Always a bug, never a store —
  // and it is what an empty number input coerces to, so it must be caught.
  if (lat === 0 && lng === 0) return null;
  return { lat, lng };
}

// 6dp is ~0.1m: far finer than any phone GPS, and keeps the box readable.
export function formatCoords(lat, lng) {
  if (lat === null || lat === undefined || lat === '') return '';
  if (lng === null || lng === undefined || lng === '') return '';
  const a = Number(lat);
  const b = Number(lng);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return '';
  return a.toFixed(6) + ', ' + b.toFixed(6);
}
